export default props => {
    if (props.test) {
        return props.onSuccess;
    } else if(props.onFailue) {
        return props.onFailue;
    } else {
        return false;
    }
}